import { AfterViewInit, Directive, ElementRef, inject, OnDestroy, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appFadeInOnView]',
})
export class FadeInOnViewDirective implements AfterViewInit, OnDestroy {
  private observer?: IntersectionObserver;

  private el: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);

  ngAfterViewInit(): void {
    // Check if IntersectionObserver is available (browser environment)
    if (typeof window !== 'undefined' && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.renderer.addClass(this.el.nativeElement, 'fade-in-visible');
              if (typeof this.observer?.unobserve === 'function') {
                this.observer.unobserve(this.el.nativeElement);
              }
            }
          });
        },
        {
          threshold: 0.4, // Tweak this as needed
        }
      );

      this.observer.observe(this.el.nativeElement);
    } else {
      this.el.nativeElement.classList.add('fade-in-visible');
    }
  }

  ngOnDestroy(): void {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
}
